import { render, staticRenderFns } from "./TitleDetailLink.vue?vue&type=template&id=4d8b179b"
import script from "./TitleDetailLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailLink.vue?vue&type=style&index=0&id=4d8b179b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports